module.exports = new __parcel__URL__("julekalender_footer.98589ca7.png").toString();